// extracted by mini-css-extract-plugin
var _1 = "infotext_icon__blh87";
var _2 = "infotext_wrapper__xac+8";
export { _1 as "icon", _2 as "wrapper" }
